import update from 'immutability-helper';
import { handleActions } from 'redux-actions';

import {
  LOAD_LIST_ONLINE_SERVICE,
  LOAD_LIST_ONLINE_SERVICE_ERROR,
  LOAD_LIST_ONLINE_SERVICE_SUCCESS,
} from '../type';
import { initialState } from './initialize';

const onlineServiceReducer = handleActions(
  new Map([
    [
      LOAD_LIST_ONLINE_SERVICE,
      state => {
        return update(state, {
          loading: { $set: true },
          error: { $set: '' },
        });
      },
    ],
    [
      LOAD_LIST_ONLINE_SERVICE_ERROR,
      (state, action) => {
        return update(state, {
          loading: { $set: false },
          error: {
            $set: action.payload,
          },
        });
      },
    ],
    [
      LOAD_LIST_ONLINE_SERVICE_SUCCESS,
      (state, action) => {
        return update(state, {
          loading: { $set: false },
          data: {
            $set: action.payload,
          },
        });
      },
    ],
  ]),
  initialState,
);

export default onlineServiceReducer;
